import { useEffect, useState } from "react";
import { GroupData, Resource, ResourcesData } from "../context/model";
import { useAppContext } from "../provider/AppContextProvider";
import {
  GROUP_SPECIFIC_RECORD_QUERY,
  RESOURCE_RECORD_CAMPAIGN_QUERY,
} from "../services/query";
import { useQuery } from "@apollo/client/react";
import { parseGroupRecordIds } from "../services/resourceGroupDataService";


export const useFetchResourcesViaId = (resourceAliasPath: string) => {
  const { updateLoading, isInitializing } = useAppContext();

  // const segment = resourceAliasPath.split("/").filter(Boolean)[0] || "";
  const [resourceAllRecord, setResourceAllRecord] = useState<Resource[]>([]);
  const [isResourceCalled, setIsResourceCalled] = useState(false);
  const { data, loading, error } = useQuery<ResourcesData>(
    RESOURCE_RECORD_CAMPAIGN_QUERY,
    { skip: isInitializing, variables: { resourceAliasPath } } //instead of resource id i will pass alias title here
  );
 
  const { data: dataGroup } = useQuery<GroupData>(GROUP_SPECIFIC_RECORD_QUERY, {
    skip: isInitializing,
  });
 
  useEffect(() => {
    if (data && data.cAResourcesCollection) {
      setIsResourceCalled(true);
      const mappedResources: Resource[] = data.cAResourcesCollection.items.map(
        (resource) => {
          // Split comma-separated group name GUIDs and trim whitespace
          const groupNameIds = parseGroupRecordIds(resource.groupName, resource.resourceType);
          const resourceTypeIdsArr = resource.resourceType ? resource.resourceType.split(",").map((id) => id.trim()) : [];
          return {
            _system: resource._system,
            imageContentHub: resource.imageContentHub,
            title: resource.title,
            shortDescription: resource.shortDescription,
            buttonURL: resource.buttonURL,
            buttonText: resource.buttonText,
            feature: resource.feature,
            resourceType: {
              items: [
                {
                  id: resourceTypeIdsArr[0], // Assuming the first ID is the primary resource type
                  title: "",
                  imageContentHub: resource.imageContentHub || null,
                  _system: {
                    id: resourceTypeIdsArr[0],
                    firstPublished: resource._system.firstPublished,
                    lastPublished: resource._system.lastPublished,
                  },
                },
              ],
            },
            groupName: {
              items:
                dataGroup?.cAGroupNameCollection?.items?.filter(
                  (item) => groupNameIds.includes(item._system.id)
                ) || [],
            },
            aliasPath: resource.aliasPath || "", // Ensure aliasPath is included
          };
        }
      );

      setResourceAllRecord(mappedResources);
    }
    if (error) {
      setIsResourceCalled(true);
    }

  }, [data, dataGroup, error]);

  useEffect(() => {
    updateLoading(loading, "CampaingResourceLoading");
  }, [loading, updateLoading]);

  return { resourceAllRecord, isResourceCalled };
};
